// extracted by mini-css-extract-plugin
export var actions = "_i2-d";
export var benefitCard = "_i2-a";
export var benefitIcon = "_i2-b";
export var benefitLabel = "_i2-c";
export var benefits = "_i2-9";
export var bodyText = "_i2-8";
export var closeButton = "_i2-2";
export var content = "_i2-3";
export var eyebrow = "_i2-4";
export var heading = "_i2-5";
export var image = "_i2-f";
export var imagePanel = "_i2-e";
export var modal = "_i2-0";
export var shell = "_i2-1";
export var title = "_i2-6";
export var titleOffer = "_i2-7";